const unit = {
  createStudentUnits: async function(studentId, unitIds) {
    const query = `
        mutation($studentId: Int!, $unitIds: [Int]!) {
          CreateStudentUnits(studentId: $studentId, unitIds: $unitIds) {
            Student_Unit_Id
          }
        }`;
    const variables = {
      studentId: parseInt(studentId),
      unitIds: unitIds.map(u => parseInt(u))
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      return res.data.CreateStudentUnits;
    });
  },

  createUnitStudents: async function(unitId, studentIds) {
    const query = `
        mutation($unitId: Int!, $studentIds: [Int]!) {
          CreateUnitStudents(unitId: $unitId, studentIds: $studentIds) {
            Student_Unit_Id
          }
        }`;
    const variables = {
      unitId: parseInt(unitId),
      studentIds: studentIds.map(s => parseInt(s))
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      return res.data.CreateUnitStudents;
    });
  },

  createStudentUnitsPairs: async function(studentUnitsPairs) {
    const query = `
        mutation($studentUnitsPairs: [StudentUnitsPair]!) {
          CreateStudentUnitsPairs(studentUnitsPairs: $studentUnitsPairs)
        }`;
    var parsedStudentUnitsPairs = [];
    studentUnitsPairs.forEach(supair => {
      parsedStudentUnitsPairs.push({
        studentId: parseInt(supair.studentId),
        unitIds: supair.unitIds.map(uid => parseInt(uid))
      });
    });
    const variables = {
      studentUnitsPairs: parsedStudentUnitsPairs
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      return res.data.CreatStudentUnitsPairs;
    });
  },

  archiveStudentUnitsPairs: async function(studentUnitsPairs) {
    const query = `
        mutation($studentUnitsPairs: [StudentUnitsPair]!) {
          ArchiveStudentUnitsPairs(studentUnitsPairs: $studentUnitsPairs)
        }`;
    var parsedStudentUnitsPairs = [];
    studentUnitsPairs.forEach(supair => {
      parsedStudentUnitsPairs.push({
        studentId: parseInt(supair.student.Student_Id),
        unitIds: supair.unitIds.map(uid => parseInt(uid))
      });
    });
    const variables = {
      studentUnitsPairs: parsedStudentUnitsPairs
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      return res.data.ArchiveStudentUnitsPairs;
    });
  },

  unarchiveStudentUnits: async function(studentUnitIds) {
    const query = `
      mutation($studentUnitIds: [Int]!) {
        UnarchiveStudentUnits(studentUnitIds: $studentUnitIds)
      }
    `;
    const variables = {
      studentUnitIds: studentUnitIds.map(s => parseInt(s))
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      return res.data.UnarchiveStudentUnits;
    });
  },

  deleteStudentUnits: async function(studentUnitIds) {
    const query = `
      mutation($studentUnitIds: [Int]!) {
        DELETESTUDENTUNITS(studentUnitIds: $studentUnitIds)
      }
    `;
    const variables = {
      studentUnitIds: studentUnitIds.map(s => parseInt(s))
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      return res.data.DELETESTUDENTUNITS;
    });
  },

  createUnit(unitToCreate) {
    const query = `
      mutation($title: String!, $description: String!, $subjectId: Int!, $scoreTemplateId: Int!) {
        CreateUnit(title: $title, description: $description, subjectId: $subjectId, scoreTemplateId: $scoreTemplateId) {
          Unit_Id
        }
      }`;
    const variables = {
      title: unitToCreate.Title,
      description: unitToCreate.Description,
      subjectId: parseInt(unitToCreate.Subject_Id),
      scoreTemplateId: parseInt(unitToCreate.Score_Template.Score_Template_Id)
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      unitToCreate.Unit_Id = res.data.CreateUnit.Unit_Id;
      return unitToCreate;
    });
  },
  updateUnit(unitToUpdate) {
    const query = `
      mutation($unitId: Int!, $title: String!, $description: String!, $subjectId: Int!, $scoreTemplateId: Int!) {
        UpdateUnit(unitId: $unitId, title: $title, description: $description, subjectId: $subjectId, scoreTemplateId: $scoreTemplateId) {
          Unit_Id
        }
      }`;
    const variables = {
      unitId: parseInt(unitToUpdate.Unit_Id),
      title: unitToUpdate.Title,
      description: unitToUpdate.Description,
      subjectId: parseInt(unitToUpdate.Subject_Id),
      scoreTemplateId: parseInt(unitToUpdate.Score_Template_Id)
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      return res.data.UpdateUnit.Unit_Id;
    });
  },

  archiveUnit: async function(unitId) {
    const query = `
      mutation($unitId: Int!) {
        ArchiveUnit(unitId: $unitId)
      }`;
    const variables = {
      unitId: parseInt(unitId)
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      res.data.ArchiveUnit;
    });
  },

  unarchiveUnit: async function(unitId) {
    const query = `
      mutation($unitId: Int!) {
        UnarchiveUnit(unitId: $unitId)
      }`;
    const variables = {
      unitId: parseInt(unitId)
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      res.data.UnarchiveUnit;
    });
  },

  deleteUnit: async function(unitId) {
    const query = `
      mutation($unitId: Int!) {
        DELETEUNIT(unitId: $unitId)
      }`;
    const variables = {
      unitId: parseInt(unitId)
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      res.data.DELETEUNIT;
    });
  }
};

export { unit };
